var S3_URL  = 'https://air-quality-monitor-data.s3.eu-west-2.amazonaws.com/live-data.json';
var S3_NASA = 'https://geos-cf-air-quality.s3.eu-west-2.amazonaws.com/geos-cf';

// ── State ──────────────────────────────────────────────────────────
var stations = [], currentIndex = 'AQI', userIndexOverride = false;
var currentMode = 'stations';
var nasaPollutant = 'PM2.5';
var activeSources = { DEFRA:true, AirGradient:true, SensorCommunity:true, BreatheLondon:true };
var nasaData = {}, nasaLoaded = false, pollLayer = null, overlaysAdded = false;
var markerEntities = [];

// ── Index / colour helpers ─────────────────────────────────────────
// Each index has breakpoints per pollutant from official sources:
// DAQI: DEFRA uk-air.defra.gov.uk (1-10 scale)
// AQI:  US EPA airnow.gov (0-500 scale)
// EAQI: EEA airindex.eea.europa.eu (0-100 scale, 6 bands)
// WHO:  WHO 2021 who.int (0-500 scale, calibrated to WHO 24hr guidelines)

var BREAKPOINTS = {
  DAQI: {
    // Source: DEFRA "Update on Implementation of the Daily Air Quality Index", April 2013
    // Table 1: The revised Daily Air Quality Index
    // Values are upper boundaries for each band 1-10 (all in µg/m³)
    // Averaging periods: O3=8hr running mean, NO2=hourly, SO2=15min(approx hourly), PM2.5=24hr mean, PM10=24hr mean
    pm25: [11,23,35,41,46,53,58,64,70,1e9],   // 24-hour mean
    pm10: [16,33,50,58,66,75,83,91,100,1e9],  // 24-hour mean
    no2:  [66,133,200,267,334,400,467,534,600,1e9],  // hourly mean
    o3:   [26,53,80,107,134,160,187,213,240,1e9],   // 8-hour running mean
    so2:  [88,176,265,354,442,531,708,886,1063,1e9], // 15-min mean (approx hourly)
    co:   null  // CO removed from DAQI in 2012 revision
  },
  AQI: {
    // Source: US EPA Technical Assistance Document May 2026 (document.airnow.gov)
    // PM2.5 breakpoints updated Feb 2024 (EPA NAAQS revision)
    // O3, NO2, SO2, CO converted from ppm/ppb to µg/m³ at 25°C, 1 atm
    pm25: [9.0,  35.4, 55.4, 125.4, 225.4, 325.4, 1e9],  // µg/m³ 24hr
    pm10: [54,   154,  254,  354,   424,   604,   1e9],   // µg/m³ 24hr
    o3:   [108,  140,  170,  210,   399,   747,   1e9],   // µg/m³ (conv. from ppm 8hr)
    no2:  [101,  191,  689,  1242,  2389,  3920,  1e9],   // µg/m³ (conv. from ppb 1hr)
    so2:  [92,   196,  485,  796,   1582,  2630,  1e9],   // µg/m³ (conv. from ppb 1hr)
    co:   [5038, 10763,14198,17633, 34808, 57708, 1e9]    // µg/m³ (conv. from ppm 8hr)
  },
  EAQI: {
    // Source: EEA European Air Quality Index, airindex.eea.europa.eu (updated 2025)
    // All pollutants use hourly concentrations, all values in µg/m³
    // 6 bands: Good, Fair, Moderate, Poor, Very Poor, Extremely Poor
    pm25: [5,15,50,90,140,1e9],   // hourly
    pm10: [15,45,120,195,270,1e9], // hourly
    o3:   [60,100,120,160,180,1e9], // hourly
    no2:  [10,25,60,100,150,1e9],  // hourly
    so2:  [20,40,125,190,275,1e9], // hourly
    co:   null  // CO not included in EAQI
  },
  WHO: {
    // Source: WHO Global Air Quality Guidelines 2021, Table 3.26
    // Published: WHO/Geneva 2021, NCBI Bookshelf NBK574591
    // Scale: 0-500 where AQI 100 = exactly at WHO 24-hour guideline value
    // Averaging: PM2.5=24hr, PM10=24hr, O3=8hr, NO2=24hr, SO2=24hr, CO=24hr
    pm25: [7.5,  15,   30,   45,   75,   150,  1e9], // WHO limit 15 µg/m³
    pm10: [22.5, 45,   90,   135,  225,  450,  1e9], // WHO limit 45 µg/m³
    o3:   [50,   100,  150,  200,  300,  500,  1e9], // WHO limit 100 µg/m³ (8hr)
    no2:  [12.5, 25,   50,   75,   125,  250,  1e9], // WHO limit 25 µg/m³
    so2:  [20,   40,   80,   120,  200,  400,  1e9], // WHO limit 40 µg/m³
    co:   [2000, 4000, 8000, 12000,20000,40000,1e9]  // WHO limit 4000 µg/m³
  }
};

// AQI output scales
var INDEX_SCALES = { DAQI: 10, AQI: 500, EAQI: 6 };

function calcIndex(raw, pollutantKey, indexName) {
  var bp = BREAKPOINTS[indexName];
  if (!bp) return raw;
  var breaks = bp[pollutantKey];
  if (!breaks) return null; // pollutant not in this index (e.g. CO not in DAQI)
  if (raw === null || raw === undefined) return null; // no data yet -- must not fall through to comparisons below (null <= n is true in JS)

  if (indexName === 'DAQI') {
    // DAQI is a simple band lookup 1-10, no interpolation
    // Source: DEFRA implementation document April 2013, Table 1
    for (var i = 0; i < breaks.length; i++) {
      if (raw <= breaks[i]) return i + 1;
    }
    return 10;
  }

  if (indexName === 'EAQI') {
    // EAQI is a simple band lookup 1-6, no interpolation
    // Source: EEA airindex.eea.europa.eu (updated 2025)
    // 1=Good, 2=Fair, 3=Moderate, 4=Poor, 5=Very Poor, 6=Extremely Poor
    for (var i = 0; i < breaks.length; i++) {
      if (raw <= breaks[i]) return i + 1;
    }
    return 6;
  }

  // AQI/WHO: EPA linear interpolation formula
  // Breakpoints are concentration upper boundaries per band
  // AQI bands: 0-50, 51-100, 101-150, 151-200, 201-300, 301-500
  var AQI_BANDS = [[0,50],[51,100],[101,150],[151,200],[201,300],[301,500]];
  for (var b = 0; b < breaks.length; b++) {
    if (raw <= breaks[b] || b === breaks.length - 1) {
      var cLo = b === 0 ? 0 : breaks[b-1];
      var cHi = breaks[b] >= 1e8 ? breaks[b-1] * 2 : breaks[b];
      var iLo = AQI_BANDS[Math.min(b, AQI_BANDS.length-1)][0];
      var iHi = AQI_BANDS[Math.min(b, AQI_BANDS.length-1)][1];
      var idx = Math.round(((iHi - iLo) / (cHi - cLo)) * (raw - cLo) + iLo);
      return Math.min(500, Math.max(0, idx));
    }
  }
  return 500;
}

function getColor(raw, pollutantKey) {
  var idx = calcIndex(raw, pollutantKey || 'pm25', currentIndex);
  var scale = INDEX_SCALES[currentIndex] || 500;
  var r = idx / scale;
  if (currentIndex === 'DAQI') r = idx / 10;
  if (r <= 0.1) return '#4ade80';
  if (r <= 0.3) return '#facc15';
  if (r <= 0.5) return '#f97316';
  if (r <= 0.7) return '#ef4444';
  if (r <= 0.9) return '#7c3aed';
  return '#7f1d1d';
}

function getIndexValue(raw, pollutantKey) {
  return calcIndex(raw, pollutantKey || 'pm25', currentIndex);
}


function updateLegend(){
  var label=document.getElementById('legend-label');
  var text=document.getElementById('legend-text');
  var grad=document.getElementById('legend-gradient');
  var grad_css = 'linear-gradient(to right,#4ade80,#facc15,#f97316,#ef4444,#7c3aed,#7f1d1d)';
  if(currentIndex==='DAQI'){label.textContent='DAQI (1-10)';text.innerHTML='<span>1</span><span>3 Low</span><span>6 Mod</span><span>9 High</span><span>10</span>';grad.style.background=grad_css;}
  else if(currentIndex==='AQI'){label.textContent='US AQI (0-500)';text.innerHTML='<span>0</span><span>50</span><span>150</span><span>300</span><span>500</span>';grad.style.background=grad_css;}
  else if(currentIndex==='EAQI'){label.textContent='EU EAQI (1-6)';text.innerHTML='<span>1 Good</span><span>2 Fair</span><span>3 Mod</span><span>4 Poor</span><span>5 V.Poor</span><span>6</span>';grad.style.background=grad_css;}
}

// ── Data normalisation ─────────────────────────────────────────────
function isInUK(lat,lon){return lat>=49.5&&lat<=61.5&&lon>=-9.5&&lon<=2.2;}
function readVal(v){if(v===undefined||v===null)return null;if(typeof v==='object'){var n=parseFloat(v.index);return(isNaN(n)||n===0)?null:n;}var n=parseFloat(v);return(isNaN(n)||n<-50||n>100000)?null:n;}
function normaliseStation(raw){
  var lat,lon;
  lat=parseFloat(raw.lat);
  lon=parseFloat(raw.lon);
  if(!lat || !lon || isNaN(lat) || isNaN(lon))return null;
  var r=raw.readings||{};
  var pm25=readVal(r.pm25!==undefined?r.pm25:r.PM25);
  var pm10=readVal(r.pm10!==undefined?r.pm10:r.PM10);
  var no2=readVal(r.no2!==undefined?r.no2:r.NO2);
  var o3=readVal(r.o3!==undefined?r.o3:r.O3);
  var so2=readVal(r.so2!==undefined?r.so2:r.SO2);
  var co=readVal(r.co!==undefined?r.co:r.CO);
  if(pm25===null&&pm10===null&&no2===null&&o3===null&&so2===null&&co===null)return null;
  var name=(raw.name||raw.id||'').replace(/-Particulate matter.*$/i,'').replace(/-Nitrogen dioxide.*$/i,'').replace(/-Ozone.*$/i,'').replace(/-Sulphur dioxide.*$/i,'').replace(/-Carbon monoxide.*$/i,'').trim();
  // Also extract running mean fields for correct index calculations
  var pm25_24h = readVal(r.pm25_24h);
  var pm10_24h = readVal(r.pm10_24h);
  var pm25_24h_daqi = readVal(r.pm25_24h_daqi);
  var pm10_24h_daqi = readVal(r.pm10_24h_daqi);
  var o3_8h    = readVal(r.o3_8h);
  var co_8h    = readVal(r.co_8h);
  return{id:raw.id,name:name,location:raw.location||raw.source,lat:lat,lon:lon,
    pm25:pm25!==null?pm25:null,pm10:pm10!==null?pm10:null,no2:no2!==null?no2:null,
    o3:o3!==null?o3:null,so2:so2!==null?so2:null,co:co!==null?co:null,
    pm25_24h:pm25_24h!==null?pm25_24h:null,pm10_24h:pm10_24h!==null?pm10_24h:null,
    pm25_24h_daqi:pm25_24h_daqi!==null?pm25_24h_daqi:null,
    pm10_24h_daqi:pm10_24h_daqi!==null?pm10_24h_daqi:null,
    o3_8h:o3_8h!==null?o3_8h:null,co_8h:co_8h!==null?co_8h:null,
    source:raw.source,updated:raw.updated,_hasPm25:pm25!==null};
}

// ── Cesium setup ───────────────────────────────────────────────────
Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI1OTZhNDQ4YS03YzVkLTQ2ODAtYTA5Yy1iMGQ3NDM2YmY3MWEiLCJpZCI6NDQxMjc5LCJpc3MiOiJodHRwczovL2FwaS5jZXNpdW0uY29tIiwiYXVkIjoidW5kZWZpbmVkX2RlZmF1bHQiLCJpYXQiOjE3ODA4MjQzNzN9.9NORRIVSebOiNu3-T9gb1Bnax-wtfirFGTQ7MgNrRvQ';

var viewer = new Cesium.Viewer('cesiumContainer', {
  imageryProvider: false, terrainProvider: new Cesium.EllipsoidTerrainProvider(),
  animation:false, baseLayerPicker:false, fullscreenButton:false, geocoder:false,
  homeButton:false, infoBox:false, sceneModePicker:false, selectionIndicator:false,
  timeline:false, navigationHelpButton:false, navigationInstructionsInitiallyVisible:false,
  creditContainer: document.createElement('div')
});

var scene = viewer.scene;
scene.backgroundColor = Cesium.Color.BLACK;
scene.globe.enableLighting = false;
scene.globe.showGroundAtmosphere = true;
scene.skyAtmosphere.show = true;
scene.skyAtmosphere.atmosphereLightIntensity = 20.0;
scene.skyBox = new Cesium.SkyBox({
  sources: {
    positiveX:'https://cesium.com/downloads/cesiumjs/releases/1.114/Build/Cesium/Assets/Textures/SkyBox/tycho2t3_80_px.jpg',
    negativeX:'https://cesium.com/downloads/cesiumjs/releases/1.114/Build/Cesium/Assets/Textures/SkyBox/tycho2t3_80_mx.jpg',
    positiveY:'https://cesium.com/downloads/cesiumjs/releases/1.114/Build/Cesium/Assets/Textures/SkyBox/tycho2t3_80_py.jpg',
    negativeY:'https://cesium.com/downloads/cesiumjs/releases/1.114/Build/Cesium/Assets/Textures/SkyBox/tycho2t3_80_my.jpg',
    positiveZ:'https://cesium.com/downloads/cesiumjs/releases/1.114/Build/Cesium/Assets/Textures/SkyBox/tycho2t3_80_pz.jpg',
    negativeZ:'https://cesium.com/downloads/cesiumjs/releases/1.114/Build/Cesium/Assets/Textures/SkyBox/tycho2t3_80_mz.jpg'
  }
});
scene.skyBox.show = true;

// Natural Earth fallback base (loads instantly)
var baseLayer = viewer.imageryLayers.addImageryProvider(
  new Cesium.TileMapServiceImageryProvider({
    url: Cesium.buildModuleUrl('Assets/Textures/NaturalEarthII'),
    fileExtension: 'jpg', maximumLevel: 5
  })
);
// Bing aerial on top when ready
Cesium.createWorldImageryAsync({ style: Cesium.IonWorldImageryStyle.AERIAL })
  .then(function(provider) {
    viewer.imageryLayers.remove(baseLayer);
    viewer.imageryLayers.add(new Cesium.ImageryLayer(provider), 0);
  }).catch(function() {});

viewer.camera.flyTo({ destination: Cesium.Cartesian3.fromDegrees(-12.18, 55.38, 22000000), duration:0 });



// ── Hover tooltip ─────────────────────────────────────────────────
var handler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
handler.setInputAction(function(movement) {
  var picked = scene.pick(movement.endPosition);
  var tooltip = document.getElementById('tooltip');
  if (Cesium.defined(picked) && picked.id && picked.id.properties) {
    var props = picked.id.properties;
    var name = props.stationName ? props.stationName.getValue() : '';
    var val = props.stationVal ? props.stationVal.getValue() : 0;
    var source = props.stationSource ? props.stationSource.getValue() : '';
    var color = props.stationColor ? props.stationColor.getValue() : '#fff';
    var pollutant = props.stationPollutant ? props.stationPollutant.getValue() : '';
    var idxVal = props.stationIndexVal ? props.stationIndexVal.getValue() : '';

    document.getElementById('tt-name').textContent = name;
    document.getElementById('tt-val').style.color = color;
    var idxDisplay = getIndexValue(val, POLLUTANT_MAP[pollutant]);
    document.getElementById('tt-val').textContent = idxDisplay;
    document.getElementById('tt-sub').textContent = pollutant + ' · ' + val.toFixed(1) + ' µg/m³ · ' + source;

    tooltip.style.display = 'block';
    tooltip.style.left = (movement.endPosition.x + 16) + 'px';
    tooltip.style.top = (movement.endPosition.y - 40) + 'px';
  } else {
    tooltip.style.display = 'none';
  }
}, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

// ── NASA GEOS-CF pollution overlay ────────────────────────────────
var NASA_VARS = ['no2','pm25','pm10','co','so2','o3'];
var NASA_LOADED = 0;

function loadNasaData() {
  NASA_VARS.forEach(function(id) {
    fetch(S3_NASA + '/' + id + '/latest.json')
      .then(function(r) { return r.json(); })
      .then(function(grid) {
        nasaData[id] = grid.data;
        NASA_LOADED++;
        if (NASA_LOADED === NASA_VARS.length) {
          nasaLoaded = true;
          if (currentMode === 'heatmap') renderNasaLayer();
        }
      })
      .catch(function() { NASA_LOADED++; });
  });
}

var EPA_COLORS = [[0,228,0],[255,255,0],[255,126,0],[255,0,0],[143,63,151],[126,0,35]];

function getEpaT(val, pollKey) {
  // Use the same BREAKPOINTS as station markers, switching by current index
  var indexBreaks = BREAKPOINTS[currentIndex] || BREAKPOINTS['AQI'];
  var breaks = indexBreaks[pollKey];
  if (!breaks) return 0;
  // breaks are upper boundaries: [band1_max, band2_max, ..., 1e9]
  var n = breaks.length;
  for (var b = 0; b < n; b++) {
    if (val <= breaks[b] || b === n - 1) {
      var lo = b === 0 ? 0 : breaks[b-1];
      var hi = breaks[b] >= 1e8 ? breaks[b-1] * 2 : breaks[b];
      var f = hi > lo ? Math.min(1, (val - lo) / (hi - lo)) : 1;
      return Math.min(1, (b + f) / n);
    }
  }
  return 1;
}

function sampleEpaColor(t) {
  t = Math.max(0, Math.min(1, t));
  var n = EPA_COLORS.length - 1;
  var i = Math.min(Math.floor(t * n), n - 1);
  var f = t * n - i;
  var lo = EPA_COLORS[i], hi = EPA_COLORS[i+1];
  return [Math.round(lo[0]+f*(hi[0]-lo[0])), Math.round(lo[1]+f*(hi[1]-lo[1])), Math.round(lo[2]+f*(hi[2]-lo[2]))];
}

function renderNasaLayer() {
  if (!nasaLoaded) return;

  // Use nasaPollutant when in heatmap mode, currentPollutant otherwise
  var renderPollutant = (currentMode === 'heatmap') ? nasaPollutant : currentPollutant;
  if (!renderPollutant) {
    if (pollLayer) { viewer.imageryLayers.remove(pollLayer, true); pollLayer = null; }
    return;
  }

  var W = 720, H = 361;
  var canvas = document.createElement('canvas');
  canvas.width = W; canvas.height = H;
  var ctx = canvas.getContext('2d');
  var img = ctx.createImageData(W, H);
  var d = img.data;

  var nasaKeyMap = {'PM2.5':'pm25','PM10':'pm10','NO2':'no2','O3':'o3','SO2':'so2','CO':'co'};
  var nasaKey = nasaKeyMap[renderPollutant] || 'pm25';
  var data = nasaData[nasaKey];
  if (!data) { return; }

  // Use shared BREAKPOINTS object for all indices
  var indexBreaks = BREAKPOINTS[currentIndex] || BREAKPOINTS['AQI'];
  var breaks = indexBreaks[nasaKey] || indexBreaks['pm25'];

  for (var row = 0; row < H; row++) {
    var dataRow = H - 1 - row;
    for (var col = 0; col < W; col++) {
      var i = dataRow * W + col;
      var val = data[i];
      var idx = (row * W + col) * 4;
      if (!isFinite(val) || val <= -9000 || val <= 0) {
        d[idx+3] = 0; continue;
      }
      // t based on current index breaks (upper boundaries, no leading 0)
      var nb = breaks.length;
      var t = 1;
      for (var b = 0; b < nb; b++) {
        if (val <= breaks[b] || b === nb - 1) {
          var cLo = b === 0 ? 0 : breaks[b-1];
          var cHi = breaks[b] >= 1e8 ? breaks[b-1] * 2 : breaks[b];
          var f = cHi > cLo ? Math.min(1, (val - cLo) / (cHi - cLo)) : 1;
          t = Math.min(1, (b + f) / nb);
          break;
        }
      }
      var rgb = sampleEpaColor(t);
      d[idx] = rgb[0]; d[idx+1] = rgb[1]; d[idx+2] = rgb[2]; d[idx+3] = 180;
    }
  }

  ctx.putImageData(img, 0, 0);
  canvas.toBlob(function(blob) {
    var url = URL.createObjectURL(blob);
    Cesium.SingleTileImageryProvider.fromUrl(url, {
      rectangle: Cesium.Rectangle.fromDegrees(-180,-90,180,90)
    }).then(function(provider) {
      if (pollLayer) viewer.imageryLayers.remove(pollLayer, true);
      pollLayer = viewer.imageryLayers.addImageryProvider(provider);
      pollLayer.alpha = 1.0;
      addCoastlines();
    });
  }, 'image/png');
}

function addCoastlines() {
  if (overlaysAdded) return;
  overlaysAdded = true;
  viewer.imageryLayers.addImageryProvider(
    new Cesium.WebMapServiceImageryProvider({
      url:'https://gibs.earthdata.nasa.gov/wms/epsg4326/best/wms.cgi',
      layers:'Coastlines_15m',
      parameters:{service:'WMS',version:'1.3.0',request:'GetMap',format:'image/png',transparent:true},
      rectangle:Cesium.Rectangle.fromDegrees(-180,-90,180,90),
      tileWidth:512,tileHeight:512
    })
  );
}

// ── Station markers ────────────────────────────────────────────────
function clearMarkers() {
  markerEntities.forEach(function(e) { viewer.entities.remove(e); });
  markerEntities = [];
}

// ── Marker canvas cache ────────────────────────────────────────────
var markerCanvasCache = {};

function makeMarkerCanvas(color, label) {
  var key = color + '_' + label;
  if (markerCanvasCache[key]) return markerCanvasCache[key];
  var size = 36;
  var cvs = document.createElement('canvas');
  cvs.width = size; cvs.height = size;
  var ctx2 = cvs.getContext('2d');
  ctx2.clearRect(0, 0, size, size);
  ctx2.beginPath();
  ctx2.arc(size/2, size/2, size/2 - 2, 0, Math.PI*2);
  ctx2.fillStyle = color;
  ctx2.fill();
  ctx2.strokeStyle = 'rgba(255,255,255,0.9)';
  ctx2.lineWidth = 2;
  ctx2.stroke();
  ctx2.fillStyle = '#fff';
  ctx2.font = 'bold ' + (label.length > 3 ? '9' : '11') + 'px sans-serif';
  ctx2.textAlign = 'center';
  ctx2.textBaseline = 'middle';
  ctx2.fillText(label, size/2, size/2);
  markerCanvasCache[key] = cvs;
  return cvs;
}

var POLLUTANT_FALLBACK = ['pm25','pm10','no2','o3','so2','co'];
var POLLUTANT_MAP = {'PM2.5':'pm25','PM10':'pm10','NO2':'no2','O3':'o3','SO2':'so2','CO':'co'};

// Per-index pollutant field mapping - picks the correct averaging period
// Sources: DEFRA April 2013, EPA May 2026, EEA 2025
var INDEX_POLLUTANT_FIELDS = {
  // NOTE: DAQI's real methodology wants SO2 as a running max-15-minute mean.
  // DEFRA's own SOS API only ever publishes hourly-resolution SO2 (confirmed
  // directly against real observations, phenomenonTime spans are always 1hr).
  // No finer-grained source is currently available, so the plain hourly
  // value is used as the best available approximation. Deliberate choice,
  // not an oversight -- revisit if a 15-min SO2 source is ever found.
  DAQI: {'PM2.5':'pm25_24h_daqi','PM10':'pm10_24h_daqi','NO2':'no2','O3':'o3_8h','SO2':'so2'},
  AQI:  {'PM2.5':'pm25_24h','PM10':'pm10_24h','NO2':'no2','O3':'o3_8h','SO2':'so2','CO':'co_8h'},
  EAQI: {'PM2.5':'pm25','PM10':'pm10','NO2':'no2','O3':'o3','SO2':'so2'},
};
var INDEX_POLLUTANTS = {
  'DAQI': ['PM2.5','PM10','NO2','O3','SO2'], // CO removed from DAQI in 2012 revision
  'AQI':  ['PM2.5','PM10','NO2','O3','SO2','CO'],
  'EAQI': ['PM2.5','PM10','NO2','O3','SO2'], // CO not included in EAQI
};
var POLLUTANT_KEYS = POLLUTANT_MAP;

function getBestValue(s) {
  var pollutants = INDEX_POLLUTANTS[currentIndex];
  if (pollutants) {
    // Composite index — find worst sub-index across all relevant pollutants
    var worstVal = null;
    var worstPollutant = null;
    var worstIndex = -1;
    var fieldMap = INDEX_POLLUTANT_FIELDS[currentIndex] || POLLUTANT_MAP;
    for (var i = 0; i < pollutants.length; i++) {
      var p = pollutants[i];
      var key = fieldMap[p] || POLLUTANT_MAP[p];
      if (!key) continue;
      var v = s[key];
      // Fall back to raw value if preferred averaging field is missing
      if ((v === null || v === undefined) && key !== POLLUTANT_MAP[p]) {
        v = s[POLLUTANT_MAP[p]];
      }
      if (v === null || v === undefined) continue;
      var idx = calcIndex(v, POLLUTANT_MAP[p], currentIndex);
      if (idx > worstIndex) {
        worstIndex = idx;
        worstVal = v;
        worstPollutant = p;
      }
    }
    if (worstVal !== null) return { val: worstVal, pollutant: worstPollutant, compositeIndex: worstIndex };
    return null;
  }
  return null;
}

// ── Capital cities for country-level view ──────────────────────────
var CAPITALS = [
  {name:'Kabul',country:'AF',lat:34.5253,lon:69.1783},{name:'Tirana',country:'AL',lat:41.3317,lon:19.8172},
  {name:'Algiers',country:'DZ',lat:36.7538,lon:3.0588},{name:'Luanda',country:'AO',lat:-8.8368,lon:13.2343},
  {name:'Buenos Aires',country:'AR',lat:-34.6118,lon:-58.4173},{name:'Yerevan',country:'AM',lat:40.1814,lon:44.5144},
  {name:'Canberra',country:'AU',lat:-35.2835,lon:149.1281},{name:'Vienna',country:'AT',lat:48.2092,lon:16.3728},
  {name:'Baku',country:'AZ',lat:40.3834,lon:49.8932},{name:'Nassau',country:'BS',lat:25.0582,lon:-77.3431},
  {name:'Manama',country:'BH',lat:26.2154,lon:50.5832},{name:'Dhaka',country:'BD',lat:23.7231,lon:90.4086},
  {name:'Minsk',country:'BY',lat:53.9678,lon:27.5766},{name:'Brussels',country:'BE',lat:50.8371,lon:4.3676},
  {name:'Thimphu',country:'BT',lat:27.4661,lon:89.6419},{name:'Sucre',country:'BO',lat:-19.0421,lon:-65.2559},
  {name:'Sarajevo',country:'BA',lat:43.8608,lon:18.4214},{name:'Brasilia',country:'BR',lat:-15.7801,lon:-47.9292},
  {name:'Sofia',country:'BG',lat:42.7105,lon:23.3238},{name:'Naypyidaw',country:'MM',lat:19.7633,lon:96.0785},
  {name:'Phnom Penh',country:'KH',lat:11.5434,lon:104.8984},{name:'Yaounde',country:'CM',lat:3.8612,lon:11.5175},
  {name:'Ottawa',country:'CA',lat:45.4235,lon:-75.6979},{name:'Santiago',country:'CL',lat:-33.45,lon:-70.6667},
  {name:'Beijing',country:'CN',lat:39.9289,lon:116.3883},{name:'Bogota',country:'CO',lat:4.7099,lon:-74.072},
  {name:'Kinshasa',country:'CD',lat:-4.3276,lon:15.3136},{name:'San Jose',country:'CR',lat:9.9402,lon:-84.1002},
  {name:'Zagreb',country:'HR',lat:45.8,lon:16.0},{name:'Havana',country:'CU',lat:23.1195,lon:-82.3783},
  {name:'Nicosia',country:'CY',lat:35.1667,lon:33.3667},{name:'Prague',country:'CZ',lat:50.0833,lon:14.4667},
  {name:'Copenhagen',country:'DK',lat:55.6761,lon:12.5683},{name:'Quito',country:'EC',lat:-0.2295,lon:-78.5243},
  {name:'Cairo',country:'EG',lat:30.0626,lon:31.2497},{name:'Tallinn',country:'EE',lat:59.4372,lon:24.7453},
  {name:'Addis Ababa',country:'ET',lat:9.025,lon:38.7469},{name:'Helsinki',country:'FI',lat:60.1756,lon:24.9342},
  {name:'Paris',country:'FR',lat:48.8566,lon:2.3522},{name:'Tbilisi',country:'GE',lat:41.6941,lon:44.8337},
  {name:'Berlin',country:'DE',lat:52.5235,lon:13.4115},{name:'Accra',country:'GH',lat:5.5401,lon:-0.2074},
  {name:'Athens',country:'GR',lat:37.9792,lon:23.7166},{name:'Guatemala City',country:'GT',lat:14.6407,lon:-90.5133},
  {name:'Budapest',country:'HU',lat:47.4984,lon:19.0408},{name:'Reykjavik',country:'IS',lat:64.1353,lon:-21.8952},
  {name:'New Delhi',country:'IN',lat:28.6353,lon:77.225},{name:'Jakarta',country:'ID',lat:-6.2146,lon:106.8451},
  {name:'Tehran',country:'IR',lat:35.7,lon:51.4167},{name:'Baghdad',country:'IQ',lat:33.3386,lon:44.3939},
  {name:'Dublin',country:'IE',lat:53.3331,lon:-6.2489},{name:'Jerusalem',country:'IL',lat:31.7784,lon:35.2066},
  {name:'Rome',country:'IT',lat:41.8955,lon:12.4823},{name:'Tokyo',country:'JP',lat:35.6897,lon:139.6922},
  {name:'Amman',country:'JO',lat:31.9394,lon:35.9349},{name:'Astana',country:'KZ',lat:51.1811,lon:71.4278},
  {name:'Nairobi',country:'KE',lat:-1.2864,lon:36.8172},{name:'Seoul',country:'KR',lat:37.5139,lon:126.9833},
  {name:'Kuwait City',country:'KW',lat:29.3697,lon:47.9783},{name:'Bishkek',country:'KG',lat:42.8679,lon:74.5938},
  {name:'Vientiane',country:'LA',lat:17.9667,lon:102.6},{name:'Riga',country:'LV',lat:56.9465,lon:24.1049},
  {name:'Beirut',country:'LB',lat:33.8872,lon:35.5154},{name:'Monrovia',country:'LR',lat:6.2996,lon:-10.7897},
  {name:'Tripoli',country:'LY',lat:32.9022,lon:13.1802},{name:'Vilnius',country:'LT',lat:54.6872,lon:25.2797},
  {name:'Luxembourg',country:'LU',lat:49.6106,lon:6.1296},{name:'Skopje',country:'MK',lat:41.9833,lon:21.3333},
  {name:'Kuala Lumpur',country:'MY',lat:3.1478,lon:101.6953},{name:'Bamako',country:'ML',lat:12.6392,lon:-8.0029},
  {name:'Valletta',country:'MT',lat:35.9042,lon:14.5189},{name:'Mexico City',country:'MX',lat:19.4285,lon:-99.1277},
  {name:'Chisinau',country:'MD',lat:47.0055,lon:28.8575},{name:'Ulaanbaatar',country:'MN',lat:47.9214,lon:106.9055},
  {name:'Podgorica',country:'ME',lat:42.4415,lon:19.2636},{name:'Rabat',country:'MA',lat:34.0253,lon:-6.8361},
  {name:'Maputo',country:'MZ',lat:-25.9686,lon:32.5804},{name:'Windhoek',country:'NA',lat:-22.5695,lon:17.0832},
  {name:'Kathmandu',country:'NP',lat:27.7167,lon:85.3167},{name:'Amsterdam',country:'NL',lat:52.3667,lon:4.8945},
  {name:'Wellington',country:'NZ',lat:-41.2865,lon:174.7762},{name:'Managua',country:'NI',lat:12.1328,lon:-86.2504},
  {name:'Abuja',country:'NG',lat:9.0556,lon:7.4914},{name:'Oslo',country:'NO',lat:59.9139,lon:10.7522},
  {name:'Muscat',country:'OM',lat:23.6086,lon:58.5922},{name:'Islamabad',country:'PK',lat:33.6989,lon:73.0369},
  {name:'Panama City',country:'PA',lat:8.9936,lon:-79.5197},{name:'Lima',country:'PE',lat:-12.0931,lon:-77.0465},
  {name:'Manila',country:'PH',lat:14.5958,lon:120.9772},{name:'Warsaw',country:'PL',lat:52.2297,lon:21.0122},
  {name:'Lisbon',country:'PT',lat:38.7139,lon:-9.1334},{name:'Doha',country:'QA',lat:25.2866,lon:51.5329},
  {name:'Bucharest',country:'RO',lat:44.4325,lon:26.1039},{name:'Moscow',country:'RU',lat:55.7558,lon:37.6176},
  {name:'Kigali',country:'RW',lat:-1.9441,lon:30.0619},{name:'Riyadh',country:'SA',lat:24.6877,lon:46.7219},
  {name:'Singapore',country:'SG',lat:1.3,lon:103.8},{name:'Bratislava',country:'SK',lat:48.1439,lon:17.1097},
  {name:'Ljubljana',country:'SI',lat:46.0514,lon:14.506},{name:'Pretoria',country:'ZA',lat:-25.7463,lon:28.1876},
  {name:'Madrid',country:'ES',lat:40.4167,lon:-3.7033},{name:'Colombo',country:'LK',lat:6.9271,lon:79.8612},
  {name:'Khartoum',country:'SD',lat:15.5518,lon:32.5324},{name:'Stockholm',country:'SE',lat:59.3328,lon:18.0645},
  {name:'Bern',country:'CH',lat:46.948,lon:7.4474},{name:'Damascus',country:'SY',lat:33.5158,lon:36.2939},
  {name:'Taipei',country:'TW',lat:25.0478,lon:121.5319},{name:'Bangkok',country:'TH',lat:13.7573,lon:100.502},
  {name:'Tunis',country:'TN',lat:36.8065,lon:10.1815},{name:'Ankara',country:'TR',lat:39.9208,lon:32.854},
  {name:'Kampala',country:'UG',lat:0.3162,lon:32.5822},{name:'Kiev',country:'UA',lat:50.4422,lon:30.5367},
  {name:'Abu Dhabi',country:'AE',lat:24.4764,lon:54.3705},{name:'London',country:'GB',lat:51.5002,lon:-0.1262},
  {name:'Washington DC',country:'US',lat:38.8921,lon:-77.0241},{name:'Montevideo',country:'UY',lat:-34.8941,lon:-56.0675},
  {name:'Tashkent',country:'UZ',lat:41.2995,lon:69.2401},{name:'Caracas',country:'VE',lat:10.4961,lon:-66.8983},
  {name:'Hanoi',country:'VN',lat:21.0245,lon:105.8412},{name:'Sanaa',country:'YE',lat:15.3556,lon:44.2081},
  {name:'Lusaka',country:'ZM',lat:-15.4145,lon:28.2833},{name:'Harare',country:'ZW',lat:-17.8178,lon:31.0447}
];

function buildCapitalMarkers() {
  // If already built, just show them
  if (capitalEntities.length) {
    capitalEntities.forEach(function(e) { e.show = true; });
    return;
  }

  CAPITALS.forEach(function(cap) {
    var withDist = stations
      .filter(function(s) { return activeSources[s.source]; })
      .map(function(s) {
        var dlat = s.lat - cap.lat;
        var dlon = s.lon - cap.lon;
        return { s: s, dist: Math.sqrt(dlat*dlat + dlon*dlon) };
      });
    withDist.sort(function(a,b){ return a.dist - b.dist; });
    var closest = withDist.slice(0, 3);
    if (!closest.length) return;

    var total = 0, count = 0, worstPollutant = null, worstVal = null;
    closest.forEach(function(item) {
      var best = getBestValue(item.s);
      if (!best) return;
      if (best.pollutant === 'PM2.5' && best.val > 500) return;
      if (best.pollutant === 'PM10' && best.val > 1000) return;
      var idx = calcIndex(best.val, POLLUTANT_MAP[best.pollutant], currentIndex);
      if (idx < 0) return;
      total += idx;
      count++;
      if (worstVal === null) { worstVal = best.val; worstPollutant = best.pollutant; }
    });
    if (!count) return;

    var avgIdx = Math.round(total / count);
    var color = getColor(worstVal, POLLUTANT_MAP[worstPollutant]);
    var cvs = makeMarkerCanvas(color, String(avgIdx));
    var e = viewer.entities.add({
      show: true,
      position: Cesium.Cartesian3.fromDegrees(cap.lon, cap.lat, 500),
      billboard: {
        image: cvs, width: 44, height: 44,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      },
      properties: {
        stationId: 'cap_' + cap.country,
        stationName: cap.name,
        stationVal: worstVal,
        stationSource: closest[0].s.source,
        stationColor: color,
        stationPollutant: worstPollutant,
        stationIndexVal: avgIdx
      }
    });
    capitalEntities.push(e);
    markerEntities.push(e);
  });
}

function addMarkers() {
  clearMarkers();
  if (!stations.length) return;
  updateStationCount();

  var rect = viewer.camera.computeViewRectangle();
  var toRender = stations;
  if (rect) {
    var west  = Cesium.Math.toDegrees(rect.west);
    var east  = Cesium.Math.toDegrees(rect.east);
    var south = Cesium.Math.toDegrees(rect.south);
    var north = Cesium.Math.toDegrees(rect.north);
    var padLat = (north - south) * 0.3;
    var padLon = (east - west) * 0.3;
    toRender = stations.filter(function(s) {
      return s.lat >= south - padLat && s.lat <= north + padLat &&
             s.lon >= west - padLon && s.lon <= east + padLon;
    });
  }

  if (toRender.length > 2000) toRender = toRender.slice(0, 2000);

  toRender.forEach(function(s) {
    if (!activeSources[s.source]) return;
    var best = getBestValue(s);
    if (!best) return;
    var raw = best.val;
    var color = getColor(raw, POLLUTANT_MAP[best.pollutant]);
    var idxVal = getIndexValue(raw, POLLUTANT_MAP[best.pollutant]);
    var label = String(Math.round(parseFloat(idxVal)));
    var cvs = makeMarkerCanvas(color, label);
    var e = viewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(s.lon, s.lat, 500),
      billboard: {
        image: cvs,
        width: 36,
        height: 36,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        scaleByDistance: new Cesium.NearFarScalar(50000, 1.5, 10000000, 0.1),
        translucencyByDistance: new Cesium.NearFarScalar(1000000, 1.0, 8000000, 0.0)
      },
      properties: {
        stationId: s.id || s.name,
        stationName: s.name || s.location || 'Unknown',
        stationVal: raw,
        stationSource: s.source,
        stationColor: color,
        stationPollutant: best.pollutant,
        stationIndexVal: idxVal
      }
    });
    markerEntities.push(e);
  });
}

// ── Camera change listener ─────────────────────────────────────────
var dataLoaded = false;
var renderTimeout = null;
var isFlying = false;

viewer.camera.moveEnd.addEventListener(function() {
  if (!dataLoaded || currentMode !== 'stations' || isFlying) return;
  clearTimeout(renderTimeout);
  renderTimeout = setTimeout(function() {
    addMarkers();
  }, 200);
});


// ── Station detail panel ────────────────────────────────────────────
var currentPanelStation = null;
var INDEX_BANDS = {
  DAQI: [{max:3,label:'Low'},{max:6,label:'Moderate'},{max:9,label:'High'},{max:10,label:'Very High'}],
  AQI:  [{max:50,label:'Good'},{max:100,label:'Moderate'},{max:150,label:'Unhealthy for Sensitive Groups'},{max:200,label:'Unhealthy'},{max:300,label:'Very Unhealthy'},{max:500,label:'Hazardous'}],
  EAQI: [{max:1,label:'Good'},{max:2,label:'Fair'},{max:3,label:'Moderate'},{max:4,label:'Poor'},{max:5,label:'Very Poor'},{max:6,label:'Extremely Poor'}],
};

function getIndexBand(idxVal) {
  var bands = INDEX_BANDS[currentIndex] || INDEX_BANDS['AQI'];
  for (var i = 0; i < bands.length; i++) {
    if (idxVal <= bands[i].max) return bands[i].label;
  }
  return bands[bands.length-1].label;
}

function openStationPanel(s, best) {
  closeCityPanel();
  currentPanelStation = s;
  var panel = document.getElementById('station-panel');
  var idxVal = Math.round(calcIndex(best.val, POLLUTANT_MAP[best.pollutant], currentIndex));
  var color = getColor(best.val, POLLUTANT_MAP[best.pollutant]);
  var band = getIndexBand(idxVal);
  var indexNames = {DAQI:'UK DAQI (1-10)', AQI:'US AQI (0-500)', EAQI:'EU EAQI (0-100)', WHO:'WHO 2021 (0-500)'};

  document.getElementById('sp-source').textContent = s.source;
  document.getElementById('sp-address').textContent = '';

  // Reverse geocode
  fetch('https://nominatim.openstreetmap.org/reverse?lat=' + s.lat + '&lon=' + s.lon + '&format=json')
    .then(function(r){ return r.json(); })
    .then(function(geo){
      var a = geo.address || {};
      var parts = [a.road || a.suburb, a.city || a.town || a.village, a.county || a.state].filter(Boolean);
      document.getElementById('sp-address').textContent = parts.join(', ');
    })
    .catch(function(){});
  document.getElementById('sp-name').textContent = s.name || s.location || 'Unknown Station';
  document.getElementById('sp-time').textContent = s.updated ? s.updated.slice(0,16).replace('T',' ') + ' UTC' : '';
  document.getElementById('sp-index-val').textContent = idxVal;
  document.getElementById('sp-index-val').style.color = color;
  document.getElementById('sp-index-name').textContent = indexNames[currentIndex] || currentIndex;
  document.getElementById('sp-index-band').textContent = band;
  document.getElementById('sp-index-band').style.color = color;
  document.getElementById('sp-main-poll').textContent = best.pollutant;

  // Pollutant readings
  var polls = document.getElementById('sp-pollutants');
  polls.innerHTML = '';
  var allPolls = INDEX_POLLUTANTS[currentIndex] || ['PM2.5','PM10','NO2','O3','SO2','CO'];
  var fieldMap = INDEX_POLLUTANT_FIELDS[currentIndex] || POLLUTANT_MAP;
  allPolls.forEach(function(p) {
    var rawKey = POLLUTANT_MAP[p];
    var preferredKey = fieldMap[p];
    var key = (preferredKey && s[preferredKey] != null) ? preferredKey : rawKey;
    var v = s[key];
    if (v === null || v === undefined || v <= 0) return;
    var pidx = Math.round(calcIndex(v, rawKey, currentIndex));
    var pcolor = getColor(v, rawKey);
    var row = document.createElement('div');
    row.className = 'sp-pollutant-row';
    var isPrimary = p === best.pollutant ? ' style="color:#fff;font-weight:600;"' : '';
    // Show raw hourly value in brackets for context
    var rawV = s[rawKey];
    var valDisplay = v.toFixed(1) + ' µg/m³';
    row.innerHTML = '<span class="sp-poll-name"' + isPrimary + '>' + p + '</span>' +
      '<span><span class="sp-poll-val">' + valDisplay + '</span>' +
      '<span class="sp-poll-idx" style="background:' + pcolor + '22;color:' + pcolor + '">' + pidx + '</span></span>';
    polls.appendChild(row);
  });

  panel.classList.add('open');

  // Fetch 24-hour history
  var HISTORY_URL = 'https://air-quality-monitor-data.s3.eu-west-2.amazonaws.com/history.json';
  fetch(HISTORY_URL + '?t=' + Date.now())
    .then(function(r) { return r.json(); })
    .then(function(history) {
      var sid = String(s.id || s.name || '');
      var entries = history[sid] || [];
      if (entries.length < 2) return;

      var mainKey = POLLUTANT_MAP[best.pollutant] || 'pm25';
      var times = entries.map(function(e){ return e.t ? e.t.slice(11,16) : ''; });
      var vals = entries.map(function(e){ return e[mainKey] || 0; });

      // Draw chart on canvas
      document.getElementById('sp-history-divider').style.display = '';
      document.getElementById('sp-history-label').style.display = '';
      var wrap = document.getElementById('sp-chart-wrap');
      wrap.style.display = '';

      var canvas = document.getElementById('sp-chart');
      var W = canvas.offsetWidth || 280;
      var H = 60;
      canvas.width = W;
      canvas.height = H;
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, W, H);

      var max = Math.max.apply(null, vals) || 1;
      var min = Math.min.apply(null, vals);
      var range = max - min || 1;
      var n = vals.length;

      // Draw line
      ctx.beginPath();
      ctx.strokeStyle = getColor(best.val, mainKey);
      ctx.lineWidth = 1.5;
      for (var i = 0; i < n; i++) {
        var x = (i / (n-1)) * (W - 4) + 2;
        var y = H - 8 - ((vals[i] - min) / range) * (H - 16);
        if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      }
      ctx.stroke();

      // Draw time labels
      ctx.fillStyle = 'rgba(255,255,255,0.25)';
      ctx.font = '8px DM Mono, monospace';
      ctx.textAlign = 'center';
      [0, Math.floor(n/2), n-1].forEach(function(i) {
        var x = (i / (n-1)) * (W - 4) + 2;
        ctx.fillText(times[i], x, H);
      });
    })
    .catch(function() {});
}

var selectedEntity = null;

function closeStationPanel() {
  document.getElementById('station-panel').classList.remove('open');
  try { if (selectedEntity) { selectedEntity.billboard.scale = new Cesium.ConstantProperty(1.0); selectedEntity = null; } } catch(e) { selectedEntity = null; }
}

// Click handler for station selection
var clickHandler = new Cesium.ScreenSpaceEventHandler(scene.canvas);
clickHandler.setInputAction(function(click) {
  var picked = scene.pick(click.position);
  if (Cesium.defined(picked) && picked.id && picked.id.properties) {
    var props = picked.id.properties;
    var stationId = props.stationId ? props.stationId.getValue() : null;
    if (!stationId) return;
    var s = stations.find(function(st) { return (st.id || st.name) === stationId; });
    if (!s) return;
    var best = getBestValue(s);
    if (!best) return;
    // Highlight selected marker
    if (selectedEntity) selectedEntity.billboard.scale = new Cesium.ConstantProperty(1.0);
    selectedEntity = picked.id;
    selectedEntity.billboard.scale = new Cesium.ConstantProperty(1.4);
    openStationPanel(s, best);
  } else {
    // Only close if click was not inside the station panel
    var panel = document.getElementById('station-panel');
    var rect = panel.getBoundingClientRect();
    var x = click.position.x, y = click.position.y;
    var insidePanel = panel.classList.contains('open') && x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    if (!insidePanel) closeStationPanel();
  }
}, Cesium.ScreenSpaceEventType.LEFT_CLICK);

// ── Data loading ───────────────────────────────────────────────────
function loadLiveData() {
  console.log('loadLiveData called');
  fetch(S3_URL + '?t=' + Date.now())
    .then(function(r) { console.log('fetch ok'); return r.json(); })
    .catch(function(e){ console.log('fetch error', e); return {stations:[]}; })
    .then(function(data) {
      console.log('Stations:', (data.stations||[]).length);

      var ts = data.updated ? data.updated.slice(0,16).replace('T',' ')+' UTC' : '';
      document.getElementById('updated').textContent = ts ? 'UPDATED '+ts : 'UPDATING HOURLY';

      var raw = data.stations || [];
      var norm = [];
      for (var i = 0; i < raw.length; i++) { var s = normaliseStation(raw[i]); if (s) norm.push(s); }
      stations = norm;
      dataLoaded = true;
      lastAltLevel = null;
      addMarkers();
      document.getElementById('status').style.display = 'none';
    })
    .catch(function() {
      document.getElementById('updated').textContent = 'DATA ERROR';
      document.getElementById('status').style.display = 'none';
    });
}



// ── UI controls ────────────────────────────────────────────────────


// EU + EEA members get EAQI (the UK is handled separately, first, below,
// since it takes priority even though geographically part of Europe).
// Matched against Nominatim's own country naming, read directly from
// the search result's display_name -- no dependency on any individual
// station having been geocoded.
var EU_EEA_COUNTRY_NAMES = ['austria','belgium','bulgaria','croatia','cyprus','czechia','czech republic','denmark','estonia','finland','france','germany','greece','hungary','ireland','italy','latvia','lithuania','luxembourg','malta','netherlands','poland','portugal','romania','slovakia','slovenia','spain','sweden','iceland','liechtenstein','norway'];

function getRecommendedIndex(countryName) {
  var c = (countryName || '').toLowerCase().trim();
  if (c === 'united kingdom' || c === 'uk') return 'DAQI';
  if (EU_EEA_COUNTRY_NAMES.indexOf(c) !== -1) return 'EAQI';
  return 'AQI';
}

function autoSwitchIndexIfNeeded(displayName) {
  if (userIndexOverride || !displayName) return;
  var parts = displayName.split(',');
  var country = parts[parts.length - 1];
  var recommended = getRecommendedIndex(country);
  if (recommended === currentIndex) return;
  var targetBtn = document.querySelector('.index-btn[onclick*="\'' + recommended + '\'"]');
  if (targetBtn) setIndex(recommended, targetBtn, true);
}

function setIndex(idx, btn, isAutomatic) {
  currentIndex = idx;
  if (!isAutomatic) userIndexOverride = true;
  document.querySelectorAll('.index-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  updateLegend();
  // Update NASA pollutant when switching index in heatmap mode
  if (currentMode === 'heatmap') {
    var indexPollutants = INDEX_POLLUTANTS[idx];
    if (indexPollutants) nasaPollutant = indexPollutants[0];
  }
  if (currentMode === 'stations') addMarkers();
  else renderNasaLayer();
  // Refresh station panel if open
  if (currentPanelStation && document.getElementById('station-panel').classList.contains('open')) {
    var best = getBestValue(currentPanelStation);
    if (best) openStationPanel(currentPanelStation, best);
  }
  // Refresh city panel if open
  if (document.getElementById('city-panel').classList.contains('open') && window._currentCityName) {
    if (window._currentCityBbox) {
      var bSouth = parseFloat(window._currentCityBbox[0]), bNorth = parseFloat(window._currentCityBbox[1]);
      var bWest  = parseFloat(window._currentCityBbox[2]), bEast  = parseFloat(window._currentCityBbox[3]);
      var savedBbox = window._currentCityBbox; // preserve before openCityPanel overwrites
      var nearby = stations.filter(function(s) {
        if (!activeSources[s.source]) return false;
        return s.lat >= bSouth && s.lat <= bNorth && s.lon >= bWest && s.lon <= bEast;
      });
      var cityData = computeCityFromStations(nearby, window._currentCityName, window._currentCityLat, window._currentCityLon, window._currentCityCountry);
      if (cityData) openCityPanel(cityData, savedBbox);
    } else {
      var cities = computeCityAverages(idx);
      var city = cities.find(function(c){ return c.name === window._currentCityName; });
      if (city) openCityPanel(city);
    }
  }
}

function setMode(mode) {
  currentMode = mode;
  var sp = document.getElementById('stations-panel');
  var hp = document.getElementById('heatmap-panel');
  var bs = document.getElementById('btn-stations');
  var bh = document.getElementById('btn-heatmap');

  if (mode === 'stations') {
    sp.style.display = '';
    hp.style.display = 'none';
    bs.classList.add('active');
    bh.classList.remove('active');

    markerEntities.forEach(function(e) { e.show = true; });
    if (pollLayer) pollLayer.show = false;
    addMarkers();
  } else {
    sp.style.display = 'none';
    hp.style.display = '';
    bs.classList.remove('active');
    bh.classList.add('active');

    markerEntities.forEach(function(e) { e.show = false; });
    renderNasaLayer();
  }
}


function toggleSource(src, btn) {
  activeSources[src] = !activeSources[src];
  btn.classList.toggle('active');
  addMarkers();
}

function updateStationCount() {
  var counts = {};
  var total = 0;
  stations.forEach(function(s) {
    if (!activeSources[s.source]) return;
    var best = getBestValue(s);
    if (!best) return;
    counts[s.source] = (counts[s.source] || 0) + 1;
    total++;
  });
  // Order sources nicely
  var order = ['DEFRA','AirGradient','SensorCommunity'];
  var parts = order.filter(function(k){ return counts[k]; }).map(function(k){ return k+': '+counts[k]; });
  // Add any other sources not in order
  Object.keys(counts).forEach(function(k){ if(order.indexOf(k)===-1) parts.push(k+': '+counts[k]); });
  document.getElementById('station-count').textContent = total + ' stations · ' + parts.join(' · ');
}

// ── Search ─────────────────────────────────────────────────────────
var acItems = [], acSelected = -1;

var _searchDebounce = null;
function onSearchInput(val) {
  acSelected = -1;
  if (val.length < 3) { document.getElementById('autocomplete-list').style.display='none'; return; }
  clearTimeout(_searchDebounce);
  _searchDebounce = setTimeout(function() { onSearchInputDebounced(val); }, 400);
}
function onSearchInputDebounced(val) {
  var ukTerms = ['united kingdom','england','scotland','wales','northern ireland',' uk ',' uk,'];
  var isUK = ukTerms.some(function(t){ return val.toLowerCase().indexOf(t) !== -1; });
  var ccParam = isUK ? '&countrycodes=gb' : '';
  fetch('https://nominatim.openstreetmap.org/search?format=json&limit=5' + ccParam + '&q=' + encodeURIComponent(val), {headers:{'Accept-Language':'en'}})
    .then(function(r) { return r.json(); })
    .then(function(data) {
      // Drop anything with a UK postcode in the name — these are always wrong-level results
      var filtered = data.filter(function(p) {
        return !/\b[A-Z]{1,2}\d{1,2}\s?\d[A-Z]{2}\b/.test(p.display_name || '');
      });
      acItems = filtered.length ? filtered : data;
      var list = document.getElementById('autocomplete-list');
      list.innerHTML = '';
      acItems.forEach(function(p, i) {
        var item = document.createElement('div');
        item.className = 'autocomplete-item';
        item.textContent = p.display_name;
        item.onmousedown = (function(idx) { return function(e) { e.preventDefault(); selectAc(idx); }; })(i);
        list.appendChild(item);
      });
      list.style.display = acItems.length ? 'block' : 'none';
    });
}

function onSearchKey(e) {
  var items = document.getElementById('autocomplete-list').querySelectorAll('.autocomplete-item');
  if (e.key==='ArrowDown') { acSelected=Math.min(acSelected+1,items.length-1); items.forEach(function(el,i){el.style.background=i===acSelected?'rgba(255,255,255,0.12)':'';});e.preventDefault(); }
  else if (e.key==='ArrowUp') { acSelected=Math.max(acSelected-1,-1); items.forEach(function(el,i){el.style.background=i===acSelected?'rgba(255,255,255,0.12)':'';});e.preventDefault(); }
  else if (e.key==='Enter') { if(acSelected>=0)selectAc(acSelected); else doSearch(); }
  else if (e.key==='Escape') { document.getElementById('autocomplete-list').style.display='none'; }
}

var lastSelectedItem = null;

function selectAc(i) {
  var item = acItems[i];
  lastSelectedItem = item;
  document.getElementById('search-input').value = item.display_name;
  document.getElementById('autocomplete-list').style.display = 'none';
  flyTo(parseFloat(item.lat), parseFloat(item.lon), item.display_name.split(',')[0], item.boundingbox, item.type, item['class'], item.addresstype, item.display_name);
}

function doSearch() {
  document.getElementById('autocomplete-list').style.display = 'none';
  var q = document.getElementById('search-input').value.trim();
  if (!q) return;
  // If user already selected from dropdown, use that
  if (lastSelectedItem && lastSelectedItem.display_name === document.getElementById('search-input').value.trim()) {
    flyTo(parseFloat(lastSelectedItem.lat), parseFloat(lastSelectedItem.lon), lastSelectedItem.display_name.split(',')[0], lastSelectedItem.boundingbox, lastSelectedItem.type, lastSelectedItem['class'], lastSelectedItem.addresstype, lastSelectedItem.display_name);
    lastSelectedItem = null;
    return;
  }
  lastSelectedItem = null;
  document.getElementById('search-result').textContent = 'Searching…';
  var ukTerms2 = ['united kingdom','england','scotland','wales','northern ireland',' uk ',' uk,'];
  var isUK2 = ukTerms2.some(function(t){ return q.toLowerCase().indexOf(t) !== -1; });
  var ccParam2 = isUK2 ? '&countrycodes=gb' : '';
  fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1' + ccParam2 + '&q=' + encodeURIComponent(q), {headers:{'Accept-Language':'en'}})
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.length) { document.getElementById('search-result').textContent='Not found'; return; }
      flyTo(parseFloat(data[0].lat), parseFloat(data[0].lon), data[0].display_name.split(',')[0], data[0].boundingbox, data[0].type, data[0]['class'], data[0].addresstype, data[0].display_name);
    });
}


function flyTo(lat, lon, name, bbox, nomType, nomClass, addresstype, fullDisplayName) {
  isFlying = false;
  var isCountrySearch = (addresstype === 'country' || addresstype === 'state' || nomType === 'country');
  var isCitySearch = !isCountrySearch && (nomClass === 'boundary' || nomClass === 'place' ||
                      nomType === 'city' || nomType === 'town' ||
                      nomType === 'administrative' || nomType === 'municipality' ||
                      nomType === 'county' || nomType === 'state_district' ||
                      nomType === 'region' || nomType === 'state');

  // Close existing panels
  closeCityPanel();
  closeStationPanel();

  if (isCitySearch && dataLoaded && bbox && bbox.length >= 4) {
    var bSouth = parseFloat(bbox[0]), bNorth = parseFloat(bbox[1]);
    var bWest  = parseFloat(bbox[2]), bEast  = parseFloat(bbox[3]);
    var latSpan = Math.abs(bNorth - bSouth), lonSpan = Math.abs(bEast - bWest);
    if (latSpan < 5 && lonSpan < 8 && bWest < bEast) {
      autoSwitchIndexIfNeeded(fullDisplayName);
      var nearby = stations.filter(function(s) {
        if (!activeSources[s.source]) return false;
        return s.lat >= bSouth && s.lat <= bNorth && s.lon >= bWest && s.lon <= bEast;
      });
      if (nearby.length >= 1) {
        var cityData = computeCityFromStations(nearby, name, lat, lon, '');
        if (cityData) { openCityPanel(cityData, bbox); }
        else { document.getElementById('search-result').textContent = name || '—'; }
      } else {
        document.getElementById('search-result').textContent = name + ' (no stations)';
      }
    } else {
      document.getElementById('search-result').textContent = name || '—';
    }
  } else if (isCitySearch && dataLoaded) {
    var cities = computeCityAverages();
    var bestCity = null, bestDist = Infinity;
    cities.forEach(function(c) {
      var d = Math.hypot(lat - c.lat, lon - c.lon);
      if (d < bestDist) { bestDist = d; bestCity = c; }
    });
    if (bestCity && bestDist < 2.0) { openCityPanel(bestCity); }
    else { document.getElementById('search-result').textContent = name || '—'; }
  } else if (isCountrySearch && dataLoaded) {
    var countryStations = [];
    if (bbox && bbox.length >= 4) {
      var bS = parseFloat(bbox[0]), bN = parseFloat(bbox[1]);
      var bW = parseFloat(bbox[2]), bE = parseFloat(bbox[3]);
      if (Math.abs(bE - bW) < 350 && bW < bE) {
        countryStations = stations.filter(function(s) {
          if (!activeSources[s.source]) return false;
          return s.lat >= bS && s.lat <= bN && s.lon >= bW && s.lon <= bE;
        });
      }
    }
    if (!countryStations.length) {
      countryStations = stations.filter(function(s) {
        if (!activeSources[s.source]) return false;
        return s.country_code && s.country_code.toLowerCase().slice(0,2) === name.toLowerCase().slice(0,2);
      });
    }
    if (countryStations.length >= 1) {
      var countryData = computeCityFromStations(countryStations, name, lat, lon, name);
      if (countryData) { openCityPanel(countryData, bbox); }
      else { document.getElementById('search-result').textContent = name || '—'; }
    } else {
      document.getElementById('search-result').textContent = name + ' (no stations)';
    }
  } else {
    // Point search — find nearest station as before
    var best = null, bestD = Infinity;
    for (var i = 0; i < stations.length; i++) {
      var d = Math.hypot(lat - stations[i].lat, lon - stations[i].lon);
      if (d < bestD) { bestD = d; best = stations[i]; }
    }
    if (best && bestD < 2.0) {
      var bestVal = getBestValue(best);
      if (bestVal) {
        var color = getColor(bestVal.val, POLLUTANT_MAP[bestVal.pollutant]);
        var idxVal = getIndexValue(bestVal.val, POLLUTANT_MAP[bestVal.pollutant]);
        document.getElementById('search-result').innerHTML = '<span style="color:'+color+'">'+idxVal+'</span>';
        openStationPanel(best, bestVal);
      } else {
        document.getElementById('search-result').textContent = name || '—';
      }
    } else {
      document.getElementById('search-result').textContent = name || '—';
    }
  }
  // Drop search marker
  if (window._searchMarker) { viewer.entities.remove(window._searchMarker); }
  window._searchMarker = viewer.entities.add({
    position: Cesium.Cartesian3.fromDegrees(lon, lat, 0),
    billboard: {
      image: (function() {
        var c = document.createElement('canvas'); c.width = 20; c.height = 20;
        var x = c.getContext('2d');
        x.beginPath(); x.arc(10,10,8,0,Math.PI*2);
        x.fillStyle='rgba(255,255,255,0.9)'; x.fill();
        x.strokeStyle='#333'; x.lineWidth=2; x.stroke();
        x.beginPath(); x.arc(10,10,3,0,Math.PI*2);
        x.fillStyle='#333'; x.fill();
        return c;
      })(),
      width: 20, height: 20,
      heightReference: Cesium.HeightReference.CLAMP_TO_GROUND
    }
  });

  // Fly to bounding box if available, otherwise fly to point
  isFlying = true;
  if (bbox && bbox.length >= 4) {
    var south = parseFloat(bbox[0]);
    var north = parseFloat(bbox[1]);
    var west  = parseFloat(bbox[2]);
    var east  = parseFloat(bbox[3]);
    var latSpan = Math.abs(north - south);
    var lonSpan = Math.abs(east - west);
    // If bbox is unreasonably large (e.g. France including overseas territories)
    // fall back to flying to the centre point with a sensible altitude
    // Detect bbox that includes overseas territories (west > east means it wraps, or massive span)
    if (latSpan > 40 || lonSpan > 60 || west > east) {
      // Country-level — fly high enough to see the whole thing
      viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(lon, lat, 5000000),
        duration: 1.5,
        complete: function() { isFlying = false; addMarkers(); }
      });
    } else {
      var rect = Cesium.Rectangle.fromDegrees(west, south, east, north);
      viewer.camera.flyTo({
        destination: rect,
        duration: 1.5,
        complete: function() { isFlying = false; addMarkers(); }
      });
    }
  } else {
    viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(lon, lat, 300000),
      duration: 1.5,
      complete: function() {
        isFlying = false;
        addMarkers();
      }
    });
  }
}

// Compute city AQI from an arbitrary list of stations (e.g. filtered by bounding box)
function computeCityFromStations(stationList, cityName, lat, lon, country) {
  var indexName = currentIndex || 'AQI';
  var KEYS = ['pm25','pm10','no2','o3','so2','co','pm25_24h','pm10_24h','pm25_24h_daqi','pm10_24h_daqi','o3_8h','co_8h'];
  var buckets = {};
  KEYS.forEach(function(k){ buckets[k] = []; });

  stationList.forEach(function(s) {
    KEYS.forEach(function(k) {
      var v = s[k];
      if (v !== null && v !== undefined && v > 0 && isFinite(v)) buckets[k].push(v);
    });
  });

  var medians = {};
  KEYS.forEach(function(k){ medians[k] = robustMedian(buckets[k]); });

  var fieldMap = INDEX_POLLUTANT_FIELDS[indexName] || POLLUTANT_MAP;
  var pollutants = INDEX_POLLUTANTS[indexName] || ['PM2.5','PM10','NO2','O3','SO2','CO'];
  var worstIdx = -1, worstPollutant = null, worstRaw = null;

  pollutants.forEach(function(p) {
    var preferredKey = fieldMap[p], rawKey = POLLUTANT_MAP[p];
    var v = (preferredKey && medians[preferredKey] != null) ? medians[preferredKey] : medians[rawKey];
    if (v === null || v === undefined) return;
    if (rawKey === 'pm25' && v > 500) return;
    if (rawKey === 'pm10' && v > 1000) return;
    var idx = calcIndex(v, rawKey, indexName);
    if (idx > worstIdx) { worstIdx = idx; worstPollutant = p; worstRaw = v; }
  });

  if (worstPollutant === null) return null;

  return {
    name: cityName,
    country: country || '',
    lat: lat, lon: lon,
    stationCount: stationList.length,
    pm25: medians.pm25, pm10: medians.pm10, no2: medians.no2,
    o3: medians.o3, so2: medians.so2, co: medians.co,
    pm25_24h: medians.pm25_24h, pm10_24h: medians.pm10_24h,
    pm25_24h_daqi: medians.pm25_24h_daqi, pm10_24h_daqi: medians.pm10_24h_daqi,
    o3_8h: medians.o3_8h, co_8h: medians.co_8h,
    compositeIndex: Math.round(worstIdx),
    mainPollutant: worstPollutant, mainRaw: worstRaw,
    color: getColor(worstRaw, POLLUTANT_MAP[worstPollutant]),
    band: getIndexBand(Math.round(worstIdx)),
    indexUsed: indexName
  };
}

// ── City Averaging Engine ──────────────────────────────────────────
var UK_CITIES = [
  {name:'London',      lat:51.507,lon:-0.128, radiusKm:30, cityMatch:['greater london','city of london','city of westminster','hackney','tower hamlets','southwark','lambeth','wandsworth','hammersmith and fulham','kensington and chelsea','islington','camden','haringey','waltham forest','newham','greenwich','lewisham','bromley','croydon','sutton','merton','kingston upon thames','richmond upon thames','hounslow','ealing','brent','barnet','enfield','harrow','hillingdon','havering','redbridge','barking and dagenham','bexley'], regionMatch:['greater london']},
  {name:'Birmingham',  lat:52.480,lon:-1.903, radiusKm:15, cityMatch:['birmingham','solihull','sandwell','dudley','wolverhampton','walsall'], regionMatch:['west midlands']},
  {name:'Manchester',  lat:53.480,lon:-2.242, radiusKm:15, cityMatch:['manchester','salford','stockport','trafford','tameside','oldham','rochdale','bury','bolton','wigan'], regionMatch:['greater manchester']},
  {name:'Leeds',       lat:53.800,lon:-1.549, radiusKm:12, cityMatch:['leeds'], regionMatch:[]},
  {name:'Sheffield',   lat:53.383,lon:-1.466, radiusKm:12, cityMatch:['sheffield','rotherham'], regionMatch:[]},
  {name:'Liverpool',   lat:53.408,lon:-2.991, radiusKm:12, cityMatch:['liverpool','knowsley','sefton','wirral','st helens'], regionMatch:['merseyside']},
  {name:'Bristol',     lat:51.454,lon:-2.588, radiusKm:12, cityMatch:['bristol','south gloucestershire','north somerset'], regionMatch:[]},
  {name:'Nottingham',  lat:52.954,lon:-1.158, radiusKm:10, cityMatch:['nottingham','gedling','broxtowe','rushcliffe'], regionMatch:[]},
  {name:'Leicester',   lat:52.637,lon:-1.133, radiusKm:10, cityMatch:['leicester','oadby and wigston','blaby'], regionMatch:[]},
  {name:'Coventry',    lat:52.408,lon:-1.510, radiusKm:10, cityMatch:['coventry'], regionMatch:[]},
  {name:'Newcastle',   lat:54.978,lon:-1.618, radiusKm:12, cityMatch:['newcastle upon tyne','gateshead','sunderland','south tyneside','north tyneside'], regionMatch:['tyne and wear']},
  {name:'Edinburgh',   lat:55.953,lon:-3.189, radiusKm:15, cityMatch:['edinburgh','city of edinburgh'], regionMatch:[]},
  {name:'Glasgow',     lat:55.864,lon:-4.252, radiusKm:15, cityMatch:['glasgow','east dunbartonshire','west dunbartonshire','east renfrewshire','renfrewshire','north lanarkshire','south lanarkshire'], regionMatch:[]},
  {name:'Cardiff',     lat:51.481,lon:-3.180, radiusKm:12, cityMatch:['cardiff'], regionMatch:[]},
  {name:'Belfast',     lat:54.597,lon:-5.930, radiusKm:12, cityMatch:['belfast'], regionMatch:[]},
  {name:'Southampton', lat:50.909,lon:-1.404, radiusKm:10, cityMatch:['southampton','eastleigh','fareham'], regionMatch:[]},
  {name:'Oxford',      lat:51.752,lon:-1.258, radiusKm:8,  cityMatch:['oxford'], regionMatch:[]},
  {name:'Cambridge',   lat:52.205,lon:0.119,  radiusKm:8,  cityMatch:['cambridge','south cambridgeshire'], regionMatch:[]},
  {name:'Brighton',    lat:50.827,lon:-0.137, radiusKm:8,  cityMatch:['brighton and hove','brighton','hove'], regionMatch:[]},
  {name:'Hull',        lat:53.745,lon:-0.336, radiusKm:10, cityMatch:['kingston upon hull','hull'], regionMatch:[]},
  {name:'Plymouth',    lat:50.376,lon:-4.144, radiusKm:10, cityMatch:['plymouth'], regionMatch:[]},
  {name:'Derby',       lat:52.921,lon:-1.477, radiusKm:10, cityMatch:['derby'], regionMatch:[]},
  {name:'York',        lat:53.960,lon:-1.087, radiusKm:8,  cityMatch:['york'], regionMatch:[]},
  {name:'Aberdeen',    lat:57.150,lon:-2.110, radiusKm:10, cityMatch:['aberdeen','aberdeenshire'], regionMatch:[]},
  {name:'Swansea',     lat:51.621,lon:-3.944, radiusKm:10, cityMatch:['swansea'], regionMatch:[]},
  {name:'Norwich',     lat:52.628,lon:1.299,  radiusKm:8,  cityMatch:['norwich'], regionMatch:[]},
  {name:'Milton Keynes',lat:52.040,lon:-0.759,radiusKm:8,  cityMatch:['milton keynes'], regionMatch:[]},
  {name:'Bournemouth', lat:50.720,lon:-1.880, radiusKm:8,  cityMatch:['bournemouth','christchurch','poole'], regionMatch:[]},
  {name:'Middlesbrough',lat:54.574,lon:-1.234,radiusKm:10, cityMatch:['middlesbrough','stockton-on-tees','hartlepool'], regionMatch:[]},
  {name:'Reading',     lat:51.455,lon:-0.971, radiusKm:10, cityMatch:['reading','wokingham','bracknell forest'], regionMatch:[]},
  {name:'Northampton', lat:52.237,lon:-0.896, radiusKm:8,  cityMatch:['northampton'], regionMatch:[]},
  {name:'Luton',       lat:51.879,lon:-0.417, radiusKm:8,  cityMatch:['luton'], regionMatch:[]},
  {name:'Peterborough',lat:52.573,lon:-0.237, radiusKm:8,  cityMatch:['peterborough'], regionMatch:[]},
  {name:'Preston',     lat:53.763,lon:-2.703, radiusKm:8,  cityMatch:['preston','south ribble'], regionMatch:[]},
  {name:'Blackpool',   lat:53.817,lon:-3.036, radiusKm:8,  cityMatch:['blackpool','fylde'], regionMatch:[]},
  {name:'Ipswich',     lat:52.058,lon:1.155,  radiusKm:8,  cityMatch:['ipswich'], regionMatch:[]},
  {name:'Gloucester',  lat:51.864,lon:-2.244, radiusKm:8,  cityMatch:['gloucester'], regionMatch:[]},
  {name:'Dundee',      lat:56.462,lon:-2.971, radiusKm:8,  cityMatch:['dundee'], regionMatch:[]},
  {name:'Derry',       lat:54.997,lon:-7.310, radiusKm:8,  cityMatch:['derry','londonderry'], regionMatch:[]},
];

// Match station to city using geocoded fields (preferred) or radius fallback
function stationMatchesCity(s, city) {
  if (s.city || s.region) {
    var sc = (s.city || '').toLowerCase();
    var sr = (s.region || '').toLowerCase();
    for (var i = 0; i < city.regionMatch.length; i++) {
      if (sr === city.regionMatch[i] || sc === city.regionMatch[i]) return true;
    }
    for (var j = 0; j < city.cityMatch.length; j++) {
      if (sc === city.cityMatch[j]) return true;
    }
    return false; // geocoded but doesn't match — don't use radius
  }
  // Not geocoded yet — fall back to radius
  return haversineKm(city.lat, city.lon, s.lat, s.lon) <= city.radiusKm;
}

function haversineKm(lat1,lon1,lat2,lon2){
  var R=6371,dLat=(lat2-lat1)*Math.PI/180,dLon=(lon2-lon1)*Math.PI/180;
  var a=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLon/2)*Math.sin(dLon/2);
  return R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));
}

function robustMedian(values){
  if(!values.length)return null;
  var sorted=values.slice().sort(function(a,b){return a-b;});
  var n=sorted.length;
  if(n===1)return sorted[0];
  if(n===2)return(sorted[0]+sorted[1])/2;
  var q1=sorted[Math.floor(n*0.25)],q3=sorted[Math.floor(n*0.75)],iqr=q3-q1;
  var filtered=n>=4?sorted.filter(function(v){return v>=q1-1.5*iqr&&v<=q3+1.5*iqr;}):sorted;
  if(!filtered.length)filtered=sorted;
  var m=filtered.length;
  return m%2===1?filtered[Math.floor(m/2)]:(filtered[Math.floor(m/2)-1]+filtered[Math.floor(m/2)])/2;
}

function computeCityAverages(indexName){
  indexName=indexName||currentIndex||'AQI';
  var KEYS=['pm25','pm10','no2','o3','so2','co','pm25_24h','pm10_24h','pm25_24h_daqi','pm10_24h_daqi','o3_8h','co_8h'];
  return UK_CITIES.map(function(city){
    var nearby=stations.filter(function(s){
      if(!activeSources[s.source])return false;
      return stationMatchesCity(s, city);
    });
    if(!nearby.length)return null;
    var buckets={};
    KEYS.forEach(function(k){buckets[k]=[];});
    nearby.forEach(function(s){
      KEYS.forEach(function(k){
        var v=s[k];
        if(v!==null&&v!==undefined&&v>0&&isFinite(v))buckets[k].push(v);
      });
    });
    var medians={};
    KEYS.forEach(function(k){medians[k]=robustMedian(buckets[k]);});
    var fieldMap=INDEX_POLLUTANT_FIELDS[indexName]||POLLUTANT_MAP;
    var pollutants=INDEX_POLLUTANTS[indexName]||['PM2.5','PM10','NO2','O3','SO2','CO'];
    var worstIdx=-1,worstPollutant=null,worstRaw=null;
    pollutants.forEach(function(p){
      var preferredKey=fieldMap[p],rawKey=POLLUTANT_MAP[p];
      var v=(preferredKey&&medians[preferredKey]!=null)?medians[preferredKey]:medians[rawKey];
      if(v===null||v===undefined)return;
      if(rawKey==='pm25'&&v>500)return;
      if(rawKey==='pm10'&&v>1000)return;
      var idx=calcIndex(v,rawKey,indexName);
      if(idx>worstIdx){worstIdx=idx;worstPollutant=p;worstRaw=v;}
    });
    if(worstPollutant===null)return null;
    return{
      name:city.name,lat:city.lat,lon:city.lon,stationCount:nearby.length,
      pm25:medians.pm25,pm10:medians.pm10,no2:medians.no2,o3:medians.o3,so2:medians.so2,co:medians.co,
      pm25_24h:medians.pm25_24h,pm10_24h:medians.pm10_24h,
      pm25_24h_daqi:medians.pm25_24h_daqi,pm10_24h_daqi:medians.pm10_24h_daqi,
      o3_8h:medians.o3_8h,co_8h:medians.co_8h,
      compositeIndex:Math.round(worstIdx),mainPollutant:worstPollutant,mainRaw:worstRaw,
      color:getColor(worstRaw,POLLUTANT_MAP[worstPollutant]),
      band:getIndexBand(Math.round(worstIdx)),indexUsed:indexName
    };
  }).filter(Boolean);
}

// ── City Panel ─────────────────────────────────────────────────────
function openCityPanel(cityData, bbox) {
  closeStationPanel();
  window._currentCityName = cityData.name;
  window._currentCityLat = cityData.lat;
  window._currentCityLon = cityData.lon;
  window._currentCityBbox = bbox || null;
  window._currentCityCountry = '';
  document.getElementById('cp-eyebrow').textContent = 'Air Quality';
  var panel = document.getElementById('city-panel');
  var indexNames = {DAQI:'UK DAQI (1-10)', AQI:'US AQI (0-500)', EAQI:'EU EAQI (1-6)'};

  document.getElementById('cp-city').textContent = cityData.name;
  document.getElementById('cp-region').textContent = '';
  document.getElementById('cp-aqi-num').textContent = cityData.compositeIndex;
  document.getElementById('cp-aqi-num').style.color = cityData.color;
  document.getElementById('cp-aqi-index').textContent = indexNames[currentIndex] || currentIndex;
  document.getElementById('cp-aqi-band').textContent = cityData.band;
  document.getElementById('cp-aqi-band').style.color = cityData.color;
  document.getElementById('cp-aqi-poll').textContent = 'Main pollutant: ' + cityData.mainPollutant;
  document.getElementById('cp-stations').textContent = cityData.stationCount + ' monitoring stations';

  var reportLink = document.getElementById('cp-report-link');
  if (cityData.name) {
    var reportParams = new URLSearchParams({ place: cityData.name.toLowerCase() });
    reportLink.href = 'city-report?' + reportParams.toString();
    reportLink.style.display = 'block';
  } else {
    reportLink.style.display = 'none';
  }

  // Pollutant breakdown
  var container = document.getElementById('cp-pollutants');
  container.innerHTML = '';
  var fieldMap = INDEX_POLLUTANT_FIELDS[currentIndex] || POLLUTANT_MAP;
  var pollutants = INDEX_POLLUTANTS[currentIndex] || ['PM2.5','PM10','NO2','O3','SO2','CO'];
  pollutants.forEach(function(p) {
    var rawKey = POLLUTANT_MAP[p];
    var preferredKey = fieldMap[p];
    var v = (preferredKey && cityData[preferredKey] != null) ? cityData[preferredKey] : cityData[rawKey];
    if (v === null || v === undefined || v <= 0) return;
    var idx = Math.round(calcIndex(v, rawKey, currentIndex));
    var color = getColor(v, rawKey);
    var isPrimary = p === cityData.mainPollutant;
    var row = document.createElement('div');
    row.className = 'cp-poll-row';
    row.innerHTML = '<span class="cp-poll-name"' + (isPrimary?' style="color:#fff;font-weight:600;"':'') + '>' + p + '</span>' +
      '<div class="cp-poll-right">' +
      '<span class="cp-poll-val">' + v.toFixed(1) + ' µg/m³</span>' +
      '<span class="cp-poll-badge" style="background:' + color + '22;color:' + color + '">' + idx + '</span>' +
      '</div>';
    container.appendChild(row);
  });

  document.getElementById('cp-updated').textContent = 'Updated ' + new Date().toUTCString().slice(0,25);
  panel.classList.add('open');

  // Update search result display
  document.getElementById('search-result').innerHTML =
    '<span style="color:' + cityData.color + '">' + cityData.compositeIndex + '</span> <span style="color:rgba(255,255,255,0.4);font-size:10px;">' + cityData.band + '</span>';
}

function closeCityPanel() {
  document.getElementById('city-panel').classList.remove('open');
  window._currentCityName = null;
}

// ── Start ──────────────────────────────────────────────────────────
updateLegend();
loadLiveData();
loadNasaData();

// Hide status as soon as stations load (NASA loads in background)
setTimeout(function() {
  document.getElementById('status').style.display = 'none';
}, 8000);